export const GarlleryIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="vuesax/linear/gallery-icon">
        <g id="gallery-icon">
          <path
            d="M5.9987 14.6661H9.9987C13.332 14.6661 14.6654 13.3328 14.6654 9.99943V5.99943C14.6654 2.6661 13.332 1.33276 9.9987 1.33276H5.9987C2.66536 1.33276 1.33203 2.6661 1.33203 5.99943V9.99943C1.33203 13.3328 2.66536 14.6661 5.9987 14.6661Z"
            stroke="var(--theme-primary-300, #9695C7)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.0013 6.66667C6.73768 6.66667 7.33464 6.06971 7.33464 5.33333C7.33464 4.59695 6.73768 4 6.0013 4C5.26492 4 4.66797 4.59695 4.66797 5.33333C4.66797 6.06971 5.26492 6.66667 6.0013 6.66667Z"
            stroke="var(--theme-primary-300, #9695C7)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.78125 12.6328L5.06792 10.4261C5.59458 10.0728 6.35458 10.1128 6.82792 10.5195L7.04792 10.7128C7.56792 11.1595 8.40792 11.1595 8.92792 10.7128L11.7012 8.3328C12.2212 7.88614 13.0612 7.88614 13.5812 8.3328L14.6679 9.26614"
            stroke="var(--theme-primary-300, #9695C7)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
